export class I18n {
    public static  getLocaleDateFormat(locale): string {
        const result = locale.substr(0, 2).toLocaleLowerCase();
        switch (result) {
            case "es":
            case "fr":
            case "el":
            case "pt":
            case "it":
                return "dd/MM/yyyy";
            case "cs":
            case "sk":
                return "dd. M. yyyy";
            case "hu":
                return "yyyy. MM. dd.";
            case "pl":
            case "ro":
            case "ru":
            case "tr":
                return "dd.MM.yyyy";
        }
        return "MM/dd/yyyy";
    }

    public static  getLocaleMomentFormat(locale): string {
        const result = locale.substr(0, 2).toLocaleLowerCase();
        switch (result) {
            case "es":
            case "fr":
            case "el":
            case "pt":
            case "it":
                return "DD/MM/YYYY HH:mm";
            case "cs":
            case "sk":
                return "DD. M. YYYY HH:mm";
            case "hu":
                return "YYYY. MM. DD. HH:mm";
            case "pl":
            case "ro":
            case "ru":
            case "tr":
                return "DD.MM.YYYY HH:mm";
        }
        return "MM/DD/YYYY h:mm a";
    }
}
